export default __webpack_public_path__ + "static/33aa-d0de7a04ed68854b9fc66b271f0766de.png";